import { useQuery } from "@tanstack/react-query";
import useAPI from "./useAPI";

export const useCheckGoogleRemediationPermissions = () => {
  const { checkGoogleRemediationPermissions } = useAPI();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["google", "remediation-permissions"],
    queryFn: async () => {
      const response = await checkGoogleRemediationPermissions();
      return response.data.has_remediation_permissions;
    },
  });

  return {
    hasRemediationPermissions: data ?? false,
    isLoading,
    error,
    refetch,
  };
};
